import { stringField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  short_name: stringField()
};
